import { render, staticRenderFns } from "./lkuDimLazzy.vue?vue&type=template&id=23b920e7"
import script from "./lkuDimLazzy.vue?vue&type=script&lang=js"
export * from "./lkuDimLazzy.vue?vue&type=script&lang=js"
import style0 from "./lkuDimLazzy.vue?vue&type=style&index=0&id=23b920e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports